import { Card } from '@veneer/core';
import tokens from '@veneer/tokens';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  display: inline-block;
  min-width: min-content;
  width: auto;
  && {
    padding: ${tokens.layout.size4};
  }

  @media (min-width: 1400px) {
    min-width: min-content;
    white-space: break-spaces;
  }

  @media (max-width: ${tokens.layout.smMax}) {
    width: 100%;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${tokens.layout.size2} 0 ${tokens.layout.size2} 0;
`;

export const CardTitle = styled.h2`
  font-size: ${tokens.typography.size3};
  line-height: ${tokens.typography.lineHeight3};
  color: ${tokens.color.gray12};
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: space-between;

  a {
    color: #024ad8;
    display: inline-block;
    border-radius: ${tokens.layout.size1};
    padding: 0 ${tokens.layout.size1};
    transition:
      box-shadow 0s,
      background-color 0.15s,
      color 0.15s;
    &:hover,
    &:focus {
      text-decoration: underline;
      color: #024ad8;
    }
    &:focus-visible {
      outline: #001cb0 solid 2px;
    }
  }
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${tokens.layout.size8};
`;

export const Link = styled.a`
  width: fit-content;
  cursor: pointer;
`;
